import { Component, OnInit, Input } from '@angular/core';
import { ProductLiftChartComponent } from '../product-lift-chart/product-lift-chart.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
HighchartsBorderRadius(Highcharts);

@Component({
	selector: 'app-product-lift-chart-r5',
	templateUrl: './product-lift-chart-r5.component.html',
	styleUrls: ['./product-lift-chart-r5.component.css']
})
export class ProductLiftChartR5Component extends ProductLiftChartComponent implements OnInit {
	public setGraphBackgroundColor: any = '#fff';
	public liftDataCount: any;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true,
		theme: 'r6-lift-tooltip'
	};
	@Input() sectionclass: string;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit() {
		if (this.sectionclass == 'r6_display_lift') {
			this.setGraphBackgroundColor = '#FFFFFF';
		}
		if (this.sectionclass.toLowerCase().includes('r6') || this.sectionclass.toLowerCase().includes('v6')) {
			this.isR6Enabled = true;
		}
		super.ngOnInit();
	}

	processResponseData() {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				name: campaignItem.campaign_name,
				id: campaignItem.campaign_id,
				average_lift: campaignItem.average_lift,
				average_baseline:
					UtilityService.isUndefinedOrNull(Number(campaignItem.average_baseline)) ||
					Number(campaignItem.average_baseline) == 0
						? '<0.01'
						: campaignItem.average_baseline,
				average_exposed_rate:
					UtilityService.isUndefinedOrNull(Number(campaignItem.average_conversion_rate)) ||
					Number(campaignItem.average_conversion_rate) == 0
						? '<0.01'
						: Number(campaignItem.average_conversion_rate),
				graphData: [],
				alignTicks: false,
				xAxis: {},
				yAxisSecondary: {},
				yAxisPrimary: {},
				yAxisSecondaryTitle: {},
				yAxisPrimaryTitle: {},
				legendLayout: {},
				title: {},
				plotOptions: {
					series: {
						events: {
							legendItemClick: function (event) {
								if (event.target.visible) {
									this.legendItem.attr({
										opacity: 0.5
									});
								} else {
									this.legendItem.attr({
										opacity: 1
									});
								}
							}
						},
						states: {
							inactive: {
								opacity: 1
							}
						}
					},
					area: {
						marker: {
							enabled: false
						}
					},
					column: {
						pointWidth: 36,
						borderWidth: 0
					}
				},
				subtitle: {},
				tooltip: {
					useHTML: true,
					padding: 0,
					backgroundColor: '#fff',
					formatter: function () {
						if (this.series.name.includes('Rate')) {
							return (
								`<div class="lift-tooltip">` + this.x + '<br/><b>' + this.series.name + ': ' + this.y + '%</b></div>'
							);
						} else {
							return (
								`<div class="lift-tooltip">` + this.x + '<br/><b>' + this.series.name + ': ' + this.y + 'x</b></div>'
							);
						}
					},
					borderRadius: 10,
					style: {
						fontSize: 12
					}
				},
				margin: [40, 80, 60, 65]
			};
			const baseline_data = [];
			const exposed_rate = [];
			let lift_data = [];
			const xAxisObj: any = {};
			const yAxisObj: any = {};
			const categories = [];
			campaignItem.data.forEach((dataObj) => {
				baseline_data.push(Number(dataObj.average_baseline));
				exposed_rate.push(Number(dataObj.average_conversion_rate));
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			xAxisObj.labels = {
				rotation: 0,
				step: 1,
				useHTML: true,
				formatter: function () {
					return `<span class='xlabel'>` + this.value + '</span>';
				}
			};
			yAxisObj.labels = {
				useHTML: true,
				formatter: function () {
					return `<span class='xlabel'>` + this.value + '</span>';
				}
			};
			yAxisObj.ceiling = 100;
			xAxisObj.categories = categories;
			xAxisObj.offset = 5;
			campaign.xAxis = xAxisObj;
			campaign['yAxis'] = yAxisObj;
			const titleObj = {
				align: 'high',
				style: {
					color: '#242424'
				},
				offset: 0,
				useHTML: true,
				rotation: 0,
				y: -15
			};
			campaign.yAxisPrimaryTitle = {
				...{},
				...titleObj,
				...{
					text: `<span class='xlabel'>Rate </span>`,
					x: 8
				}
			};
			campaign.yAxisSecondaryTitle = {
				...{},
				...titleObj,
				...{
					text: `<span class='xlabel'> Lift </span>`,
					x: -8
				}
			};

			campaign.yAxisSecondary['labels'] = {
				useHTML: true,
				formatter: function () {
					return `<span class='xlabel'>` + this.value + '</span>';
				}
			};
			campaign.yAxisSecondary['ceiling'] = 100;
			campaign.yAxisPrimary['labels'] = {
				useHTML: true,
				formatter: function () {
					return `<span class='xlabel'>` + this.value + '%</span>';
				}
			};
			campaign.graphData = [
				{
					type: 'line',
					name: 'Exposed Rate',
					dashStyle: 'ShortDash',
					data: exposed_rate,
					marker: {
						symbol: 'url(../../../../../assets/images/graph-dot-circle.png)'
					},
					yAxis: 1,
					color: '#d8d8d8',
					index: 2
				},
				{
					type: 'line',
					name: 'Baseline Rate',
					data: baseline_data,
					color: '#000',
					yAxis: 1,
					marker: {
						fillColor: '#FFFFFF',
						lineWidth: 1,
						lineColor: null,
						symbol: 'circle'
					},
					index: 1
				},
				{
					type: 'column',
					name: 'Lift',
					data: lift_data,
					color: this.colorPalette.primaryColor,
					yAxis: 0,
					marker: {
						symbol: 'circle'
					},
					borderRadiusTopLeft: '50%',
					borderRadiusTopRight: '50%',
					borderRadiusBottomLeft: '50%',
					borderRadiusBottomRight: '50%',
					index: 0
				}
			];
			return campaign;
		});
		this.liftDataCount =
			this.campaignsList[0] && this.campaignsList[0].graphData[2] && this.campaignsList[0].graphData[2].data.length
				? this.campaignsList[0].graphData[2].data.length
				: 0;
		this.configGraphOptions();
	}

	public configGraphOptions() {
		this.campaignsList.forEach((campaign, index) => {
			campaign.legendLayout = {
				layout: 'horizontal',
				symbolHeight: 0,
				symbolWidth: 0,
				align: 'center',
				verticalAlign: 'bottom',
				floating: true,
				itemMarginBottom: 10,
				itemMarginTop: 5,
				useHTML: true,
				itemStyle: {
					color: '#262626',
					fontStyle: 'italic',
					fontSize: '12px',
					fontWeight: 'normal',
					fontFamily: 'Lora !important'
				},
				labelFormatter: function () {
					if (this.name === 'Exposed Rate') {
						return (
							"<img src='../../../../../assets/images/dot-circle.png' width='20' height='20'><span style='margin-left: 10px; position:relative; top:-5px;' class='xlabel'>" +
							this.name +
							'</span>'
						);
					}
					if (this.name === 'Baseline Rate') {
						return (
							"<img src='../../../../../assets/images/circle.png' width='20' height='20'><span style='margin-left: 10px; position:relative; top:-5px;' class='xlabel'>" +
							this.name +
							'</span>'
						);
					} else if (this.name === 'Lift') {
						return (
							`<i class="fa fa-circle primary-color" style="font-size: 22px"></i><span style='margin-left: 10px; position:relative; top:-5px;' class='xlabel'>` +
							this.name +
							'</span>'
						);
					}
				}
			};
			campaign.title = {
				text: null
			};
			campaign.subtitle = !this.isR6Enabled
				? {
						useHTML: true,
						align: 'left',
						clasName: 'subtitle',
						text:
							'<p style="padding:10px; width:340px"><b style="margin-left:7%;margin-right:10%">Lift:&nbsp;&nbsp;&nbsp;&nbsp;' +
							(Number(campaign.average_lift) > 99 ? '>99 ' : Number(campaign.average_lift)) +
							'x  </b>' +
							' <b>Exposed Rate:&nbsp;&nbsp;&nbsp;&nbsp;' +
							campaign.average_exposed_rate +
							'%</b>    <b style="margin-left:10%">Baseline Rate:&nbsp;&nbsp;&nbsp;&nbsp;' +
							campaign.average_baseline +
							'% </b></p>',
						style: {
							fontSize: '9px',
							color: '#d8d8d8'
						}
				  }
				: {};
		});
	}

	moveToSelectedCarousel(index) {
		if (this.campaignsList.length > 1) {
			this.getDisplayIndex = index;
			this.campaignCarouselItem = this.campaignsList[index];
			this.liftDataCount = this.campaignCarouselItem.graphData[2].data.length;
		}
	}
}
